import React from 'react'
import { useNavigate, useParams, useRouteContext } from '@tanstack/react-router'
import { Accordion, Button, CardGroup, Col, Container, Modal, Row } from 'react-bootstrap'
import { useQueryClient } from '@tanstack/react-query'

import Card from "@/components/shared/Card";
import { DetailCard } from '@/components/components.js'
import KendoTableClientState from "@/components/shared/tables/KendoTableClientState";
import { CHLD } from '@/models/chld.tsx'
import { ENRL } from '@/models.ts'
import { CAPSDACTable, Filter, useChildTableColumns, useFamiTableColumns, useEnrlTableColumns } from '@/components/table'
import { useChildData, useCoreData, useCSPPIDMatches, useLeaData, useFileSubmissionState } from '@/queries.ts'
import { FileStatusEnum, FileSubmission, ValidationError } from '@/models/file-submission.tsx'
import { FileSubmissionStatus } from '@/pages/SubmissionsPage'
import { CSPPIDMatch, CSPPIDMatchLEA, MatchLEAStatus, csppidMatchMutationFunctions } from '@/models/mid.tsx'
import LayoutContentArea from '@/components/layout/LayoutContentArea'

export default function MidResolutionPage() {
    return (
       <LayoutContentArea 
            headingText="Multiple Identifiers Resolutions"
        >
            <MidsTable />
        </LayoutContentArea>
    );
}

export function MidsTable() {
  const leaId = useParams({ from: "/$leaid" })?.leaid;
  const navigate = useNavigate()
  const { data, error } = useCSPPIDMatches(leaId)
  const [modalMid, setModalMid] = React.useState<CSPPIDMatch | undefined>(undefined)
  const handleCloseMid = () => setModalMid(undefined)

  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>(
    []
  )

  const columns: GridColumnProps[] = [
    { id: "CSPPID", field: "Match.CSPPID", title: "CSPPID" },
    { id: "MatchedCSPPID", field: "Match.MatchedCSPPID", title: "Matched CSPPID" },
    { id: "Criteria", field: "Match.Criteria", title: "Criteria" },
    { id: "Status", field: "Status", title: "Status" },
    { id: "UpdateDate", field: "Match.UpdateDate", title: "Update Date" },
    { id: "CreateDate", field: "Match.CreateDate", title: "Create Date" },
    //{ id: "Action", field: "Action", title: "Action" },
  ];

  return (
    <div className="px-3 table-container">
      <Card className="mb-3 no-padding card-border">
        <KendoTableClientState
          data={data}
          columns={columns}
          error={error}
          onRowClick={(event: GridRowClickEvent) => {
            const matchLEA: CSPPIDMatchLEA = event.dataItem as CSPPIDMatchLEA;
            navigate({
              to: "/$leaid/mid/$entityid",
              params: { leaid: leaId, entityid: matchLEA.CSPPIDMatchId },
            }).catch((error) => {
              console.error("Navigation error:", error);
            });
          }}
        />
      </Card>
    </div>
  )
}
